export class CurrencyFormat {
    static readonly FORMAT = 'INR';
}
